export class Filter { 
    public key: string;
    public values: Array<any>;
    public description: string;

    constructor({ key, values } : { key: string, values: Array<any> }) {
        this.key = key;
        this.values = values;
        this.description = key.replace(/([A-Z])/g, ' $1').trim();
    }
}